// removed by extract-text-webpack-plugin
module.exports = {"main":"navigation-main--2gRgR","logo":"navigation-logo--27H0o","icon":"navigation-icon--1d_8V","wordmark":"navigation-wordmark--IeJfd","list":"navigation-list--3myYf","item":"navigation-item--27RJu","link":"navigation-link--3g-98","corner":"navigation-corner--1WqAp","activeLink":"navigation-activeLink--nB-4P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/navigation.scss
// module id = 3kDo
// module chunks = 4